import React, { useState } from 'react';
import { Box, Typography, IconButton, Collapse } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

interface CustomCollapsibleProps {
  headerText: string;
  content: JSX.Element | null;
  headerStyle?: React.CSSProperties;
  collapsed?: boolean;
  style?: { [key: string]: any };
  type?: string;
}

const componentTypes = {
  styled: 'styled',
  basic: 'basic'
};

const CollapsibleComponent: React.FC<CustomCollapsibleProps> = ({
  headerText,
  content,
  headerStyle,
  collapsed= true,
  style = {},
  type = componentTypes.styled
}) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);
  const isBasicComponent = type === componentTypes.basic;
  const customStyles = {
    containerStyle: isBasicComponent ? styles.plainContainer : styles.container,
    collapsibleHeaderStyle: isBasicComponent ? styles.plainCollapsibleHeader : styles.collapsibleHeader,
    headerTextStyle: isBasicComponent ? styles.plainHeaderText : styles.headerText,
    contentStyle: isBasicComponent ? {} : styles.content
  };

  return (
    <Box sx={[customStyles.containerStyle, style]}>
      <Box onClick={() => setIsCollapsed(!isCollapsed)} sx={{ ...customStyles.collapsibleHeaderStyle, ...headerStyle }}>
        <Typography sx={customStyles.headerTextStyle}>{headerText}</Typography>
        <IconButton size="small">
          {isCollapsed ? <ExpandMore /> : <ExpandLess />}
        </IconButton>
      </Box>
      <Collapse in={!isCollapsed}>
        <Box sx={customStyles.contentStyle}>{content}</Box>
      </Collapse>
    </Box>
  );
};

const styles = {
  container: {
    border: '1px solid #ccc',
    borderRadius: '5px',
    padding: '5px',
    backgroundColor: '#fff',
    marginBottom: '5px'
  },
  plainContainer: {
    padding: '5px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    marginBottom: '5px',
    pr: '10px',
    pl: '10px',
    pt: '5px',
    pb: '5px',
  },
  collapsibleHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingX: '10px',
    paddingY: '0px',
    backgroundColor: '#f0f0f0',
    cursor: 'pointer'
  },
  plainCollapsibleHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerText: {
    fontWeight: 'bold',
    color: '#333'
  },
  plainHeaderText: {
    fontWeight: 'bold',
    color: '#6e6e6e',
  },
  content: {
    padding: '10px',
    backgroundColor: '#fff'
  }
};

export default CollapsibleComponent;
